import React from 'react';
import classnames from 'classnames';

const LegacyButton = ({
  theme,
  size,
  sharp,
  children,
  disabled,
  bleed,
  type = 'button',
  onClick = () => {},
}) => {
  const buttonTheme = {
    'c-button--primary': theme === 'primary',
    'c-button--secondary': theme === 'secondary',
    'c-button--faux': theme === 'faux',
  };
  const buttonSize = {
    'c-button--large': size === 'large',
    'c-button--small': size === 'small',
  };
  const buttonSharp = {
    'c-button--sharp-left': sharp === 'left',
    'c-button--sharp-right': sharp === 'right',
  };
  const buttonBleed = {
    'c-button--full-bleed': bleed === 'full',
  };
  const classes = classnames('c-button', {
    ...buttonTheme,
    ...buttonSize,
    ...buttonSharp,
    ...buttonBleed,
  });

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled === true}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default LegacyButton;
